import { FETCH_FILIALES, FETCH_FILIALES_X_ZONAS, FETCH_FILIALES_X_ZONAS_X_AREAS } from '../actions';

export default function(state = [], action) {
  switch (action.type) {
    case FETCH_FILIALES:
      return !action.payload.data ? [] : action.payload.data.itemList;
    case FETCH_FILIALES_X_ZONAS:
      return !action.payload.data ? [] : action.payload.data.listadoZonaFilial;
    case FETCH_FILIALES_X_ZONAS_X_AREAS:
      return !action.payload.data ? [] : action.payload.data.filial;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Filiales.js